import { Select } from "@/components/flexkit/select/Select";
import { RoleFilterValue } from "@/components/settings/organization/members/members-utils";
import { type FC } from "react";

function toRoleFilterValue(value: string): RoleFilterValue {
    if (isRoleFilterValue(value)) {
        return value;
    }
    // defaulting to 'All' if the value is unrecognized
    return RoleFilterValue.All;
}

function isRoleFilterValue(value: string): value is RoleFilterValue {
    return Object.values(RoleFilterValue).includes(value as RoleFilterValue);
}

const roleFilterOptions = [
    {
        value: RoleFilterValue.All,
        label: "All roles",
    },
    {
        value: RoleFilterValue.Admin,
        label: "Admin",
    },
    {
        value: RoleFilterValue.Member,
        label: "Member",
    },
];

type MemberRoleFilterProps = {
    value: RoleFilterValue;
    onChange: (value: RoleFilterValue) => void;
};

export const MemberRoleFilter: FC<MemberRoleFilterProps> = ({ value, onChange }) => {
    return (
        <Select
            data-testid="member-role-filter-trigger"
            value={value}
            onValueChange={(v) => onChange(toRoleFilterValue(v))}
            placeholder="Select role"
            className="@lg:min-w-36 grow"
        >
            {roleFilterOptions.map((option) => (
                <Select.Item key={option.value} value={option.value}>
                    {option.label}
                </Select.Item>
            ))}
        </Select>
    );
};
